import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 5px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  flex-direction: row;
  align-items: flex-start;
`

export const TextRow = styled(Row)`
  align-items: flex-end;
  margin-bottom: 4px;
  gap: 7px;
`

export const LogDataContainer = styled.pre`
  width: 720px;
  max-height: 30vh;
  padding: 6px 10px;
  background-color: #F7F7F7;
  border: 1px solid #DDDDDD;
  border-radius: 5px;
  overflow: auto;

  &:last-child {
    margin-bottom: 8px;
  }
`

export const ActionBlock = styled.div`
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  padding: 3px 8px;
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 500;
  background-color: ${({ action }) => {
    switch (action) {
      case 'create': return '#44CF6C'
      case 'update': return '#35A7FF'
      case 'delete': return '#E74C3C'
      default: return '#F2DEDE'
    }
  }};
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 15px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 0px;
`
